import { cn } from "@/lib/utils";

const PlaceholderValue = ({ className }: { className?: string }) => (
  <span className={cn("text-neutral-alpha-300", className)}>—</span>
);

export { PlaceholderValue };
